import { codeBlockControlChar } from "./controlChars.js";
import { type KeywordsType, keywords, keywordsObject } from "./keywords.js";
import { allModifiers } from "./modifiers.js";

export const controlCharsRegEx = /(===)|(---)|(\.\.\.)/i;

export function keywordsRegExString(keywords: readonly KeywordsType[]) {
  let string = "";
  let kw: string;
  keywords.forEach((keyword, idx) => {
    switch (keyword) {
      case "*:":
        kw = "\\*:";
        break;

      case "**:":
        kw = "\\*\\*:";
        break;

      default:
        kw = keyword;
    }
    const r = `(${kw})`;
    if (idx === keywords.length - 1) {
      string = string.concat(r);
    } else {
      string = string.concat(r, "|");
    }
  });
  return string;
}

export const modifierCorrectIndentationMatch = new RegExp(
  `^\s{2}((${allModifiers.join(")|(")}))(.*)$`,
);

export const modifierRegex = new RegExp(
  `^\\s*((${allModifiers.join(")|(")}))(.*)$`,
);

export const modifierWhiteSpaceMatch = new RegExp(
  `(^|\s)((${allModifiers.join(")|(")}))(.*)$`,
);

const noBackDropModifiers = allModifiers.filter((mod) => mod !== keywordsObject["background:"].keyword)
export const modifierNoBackdropWhiteSpaceMatch = new RegExp(
  `(^|\s)((${noBackDropModifiers.join(")|(")}))(.*)$`,
);

export const allKeywordsAndModifiers = `${keywordsRegExString(keywords)}|(${allModifiers.join(")|(")})`;

export const keywordAndModifierRegex = new RegExp(
  // match indentation at start.
  `^(\\s\\s)?(${allKeywordsAndModifiers})(.*)`,
  "i",
);

export const readRegEx = new RegExp(
  `^${keywordsObject["read:"].keyword}(.*)$`
)

export const codeBlockRegEx = new RegExp(
  `${codeBlockControlChar}(.*)`
)

export const urlSafeRegEx = new RegExp(/^[a-zA-Z0-9.\/_~-]*$/)

export const reservedWordsRegEx = new RegExp(/PAGE|READ/);
export const trailingSlashRegEX = new RegExp(/.*\/\s*$/);
